import React from 'react'
import {Link, Outlet, Route, Routes, useLocation} from 'react-router-dom'
import {UsersListWrapper} from '../expense-purchase-order/users-list/UsersList'
import clsx from 'clsx'
import {Badge} from 'react-bootstrap'
import PatientCreate from '../expense-purchase-order/users-list/PatientCreate'
import {DraftWrapper} from '../expense-purchase-order/draft/UsersList'
import {AwaitApprovalWrapper} from '../expense-purchase-order/await-approval/UsersList'
import {VoidedWrapper} from '../expense-purchase-order/voided/UsersList'
import {ApprovedWrapper} from '../expense-purchase-order/approved/UsersList'
import {PartialWrapper} from '../expense-purchase-order/partial/UsersList'
import {CompletelyWrapper} from '../expense-purchase-order/completely/UsersList'
import IncomeDocumentDetailPage from '../../../components/app/IncomeDocumentDetailPage'
import IncomeDocumentPDFPage from '../../../components/app/IncomeDocumentPDFPage'

const pathTabs = [
  ['/expense-purchase-asset-order', 'ทั้งหมด'],
  ['/expense-purchase-asset-order/draft', 'ร่าง'],
  ['/expense-purchase-asset-order/await-approval', 'รออนุมัติ'],
  ['/expense-purchase-asset-order/approved', 'อนุมัติแล้ว'],
  ['/expense-purchase-asset-order/partial', 'ออกบางส่วน'],
  ['/expense-purchase-asset-order/completely', 'ออกครบแล้ว'],
  ['/expense-purchase-asset-order/voided', 'ถังขยะ'],
]

export const PatientTabs = ({count}: any) => {
  const location = useLocation()
  const activeTab = location.pathname

  return (
    <div className='patient-tabs'>
      {pathTabs.map((item, index) => (
        <Link
          to={item[0]}
          key={index}
          className={clsx('patient-tabs__item', {
            'patient-tabs__item--active': activeTab === item[0],
          })}
        >
          <h4 className='label mb-0'>
            {item[1]}
            {!!count[index] && (
              <Badge className='ms-2' text='white' bg='dark'>
                {count[index]}
              </Badge>
            )}
          </h4>
        </Link>
      ))}
    </div>
  )
}

const ExpensePurchaseOrderAssetPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <UsersListWrapper />
            </>
          }
        />
        <Route
          path='/draft'
          element={
            <>
              <DraftWrapper />
            </>
          }
        />
        <Route
          path='/await-approval'
          element={
            <>
              <AwaitApprovalWrapper />
            </>
          }
        />
        <Route
          path='/approved'
          element={
            <>
              <ApprovedWrapper />
            </>
          }
        />
        <Route
          path='/completely'
          element={
            <>
              <CompletelyWrapper />
            </>
          }
        />
        <Route
          path='/partial'
          element={
            <>
              <PartialWrapper />
            </>
          }
        />
        <Route
          path='/voided'
          element={
            <>
              <VoidedWrapper />
            </>
          }
        />
        <Route
          path='/create'
          element={
            <>
              <PatientCreate />
            </>
          }
        />
        <Route
          path='/:id/edit'
          element={
            <>
              <PatientCreate />
            </>
          }
        />
        <Route
          path='/:id/detail'
          element={
            <>
              <IncomeDocumentDetailPage />
            </>
          }
        />
        <Route
          path='/:id/print'
          element={
            <>
              <IncomeDocumentPDFPage />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default ExpensePurchaseOrderAssetPage
